import React from 'react'

export const IconFilter = () => (
  <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="1" y1="1.73389" x2="9" y2="1.73389" stroke="#DE0C4B" strokeWidth="2" strokeLinecap="round" />
    <line x1="1" y1="4.68652" x2="6" y2="4.68652" stroke="#DE0C4B" strokeWidth="2" strokeLinecap="round" />
    <line x1="1" y1="7.63965" x2="3" y2="7.63965" stroke="#DE0C4B" strokeWidth="2" strokeLinecap="round" />
  </svg>
)
